module.exports = __webpack_public_path__ + "static/media/Nunito-Regular.2cd487d1.ttf";